
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"17","height":"17","rx":"3.5","stroke":"currentColor"}}),_c('g',{attrs:{"clip-path":"url(#clip0)","fill":"currentColor"}},[_c('path',{attrs:{"d":"M7.273 4.5a.355.355 0 01.355.354v2.414a.353.353 0 01-.355.354h-2.42a.355.355 0 01-.25-.604.355.355 0 01.25-.103H6.92v-2.06a.353.353 0 01.354-.355zM4.853 10.5h2.42a.355.355 0 01.355.353v2.42a.353.353 0 01-.355.354.355.355 0 01-.354-.354v-2.066H4.853a.355.355 0 01-.25-.604.355.355 0 01.25-.103zM10.853 10.5h2.426a.355.355 0 01.25.604.355.355 0 01-.25.103h-2.071v2.066a.354.354 0 01-.71 0v-2.42a.353.353 0 01.355-.353zM10.853 4.5a.355.355 0 01.355.354v2.06h2.07a.355.355 0 01.251.604.355.355 0 01-.25.104h-2.426a.355.355 0 01-.354-.354V4.854a.353.353 0 01.354-.354zM5.466 5.816a.354.354 0 01-.25-.105L3.604 4.104a.354.354 0 11.502-.501l1.611 1.61a.354.354 0 01-.25.604v-.001zM12.854 5.317a.355.355 0 01-.348-.423.353.353 0 01.097-.181l1.618-1.61a.355.355 0 01.502.502l-1.618 1.607a.354.354 0 01-.251.105zM14.466 14.816a.353.353 0 01-.245-.103l-1.618-1.61a.354.354 0 01.25-.604c.095 0 .185.037.252.104l1.612 1.614a.354.354 0 01-.25.605v-.006zM3.348 14.802a.355.355 0 01-.25-.599l1.613-1.615a.355.355 0 01.5.501L3.599 14.7a.353.353 0 01-.25.103z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(2.999 3)","d":"M0 0h12v12H0z"}})])])])
          )
        }
      }
    